<template>
  <div class="general-tab">
    <div class="general-tab__button-wrapper"
         v-if="$hasUserPermission('PER013')">
      <group-management-button
        @refresh="refreshData(true)"
      />
    </div>
    <maintenance-status-section
      class="mb-3"
      :status="maintenanceStatus"
      :loading="loadingMaintenanceStatus"
    />
    <operating-information-section
      class="mb-3 avoid-break"
      :chart-data="chartsData"
      :loading="loadingOperatingInformation"
    />
    <maintenance-group-status
      class="avoid-break normal-font-size-print"
      :items="maintenanceGroupStatus"
      :loading="loadingMaintenanceGroupStatus"
    />
  </div>
</template>

<script>
import globalEventBus from '@/services/globalEventBus';
import engineeringEvents from '@/domain/events/engineering';
import MaintenanceGroupStatus from '@/domain/components/installation/engineering/coolingMaintenance/general/MaintenanceGroupStatus';
import Service
  from '@/domain/services/installation/engineering/coolingMaintenance/coolingMaintenanceService';
import GroupManagementButton
  from '@/domain/components/installation/engineering/coolingMaintenance/general/modal/GroupManagementButton';
import MaintenanceStatusSection
  from '@/domain/components/installation/engineering/coolingMaintenance/general/MaintenanceStatusSection';
import OperatingInformationSection
  from '@/domain/components/installation/engineering/coolingMaintenance/general/OperatingInformationSection';

export default {
  name: 'CoolingMaintenanceGeneralTab',
  props: {
    tabInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    GroupManagementButton,
    MaintenanceStatusSection,
    OperatingInformationSection,
    MaintenanceGroupStatus,
  },
  data: () => ({
    maintenanceStatus: null,
    loadingMaintenanceStatus: false,
    maintenanceGroupStatus: null,
    loadingMaintenanceGroupStatus: false,
    chartsData: null,
    loadingOperatingInformation: false,
  }),
  created() {
    this.initListeners();
    this.refreshData(true);
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    initListeners() {
      globalEventBus.on(engineeringEvents.refreshDataTab, this.refreshData);
    },
    removeListeners() {
      globalEventBus.off(engineeringEvents.refreshDataTab, this.refreshData);
    },
    getMaintenanceStatus(showLoading) {
      const { assetModuleId } = this.$route.params;
      this.loadingMaintenanceStatus = showLoading;

      Service.getMaintenanceStatus(assetModuleId)
        .then((data) => {
          this.maintenanceStatus = data;
        })
        .finally(() => {
        this.loadingMaintenanceStatus = false;
      });
    },
    getOperatingInformationCharts(showLoading) {
      const { assetModuleId } = this.$route.params;
      this.loadingOperatingInformation = showLoading;

      Service.getOperatingInformationCharts(assetModuleId)
        .then((data) => {
          this.chartsData = data;
        })
        .finally(() => {
        this.loadingOperatingInformation = false;
      });
    },
    getGroupStatus(showLoading) {
      const { assetModuleId } = this.$route.params;
      this.loadingMaintenanceGroupStatus = showLoading;

      Service.getGroupStatus(assetModuleId).then((data) => {
        this.maintenanceGroupStatus = data;
      }).finally(() => {
        this.loadingMaintenanceGroupStatus = false;
      });
    },
    refreshData(showLoading) {
      if (this.tabInfo.status?.lastUpdate) {
        this.getMaintenanceStatus(showLoading);
        this.getOperatingInformationCharts(showLoading);
        this.getGroupStatus(showLoading);
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .general-tab
    &__button-wrapper
      display: flex
      justify-content: flex-end
      margin-bottom: 10px
</style>
